import {makeStyles} from "@material-ui/core";

export default function ProdutosListaCss() {
    return makeStyles(theme => ({
        root: {
            marginTop: 20
        },
    }));
}